<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
    

        <!-- LIST -->
        <el-col :span="24">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title"> Available Classrooms</h4>
           
            </div>
            <div v-if="error">{{error}}</div>
            <el-row style="margin-top:30px; margin-bottom: 10px">
              
                Filter available classrooms
                <br><br>
                <el-form label-position="top"  size="small" >  

                  <el-col :span="18" style="">

                    <el-select
                      size="small"
                      class="form-group border-input"
                      placeholder="Select Days"
                      v-model="days"
                      @change="getClassrooms"
                    >
                    
                      <el-option
                        v-for="day in daysArray"
                        class="select-default"
                        :value="day.value"
                        :label="day.label"
                        :key="day.value"
                      ></el-option>
                    </el-select> 
<el-checkbox v-model="showAllDates" @change="calculateMonth">All Months</el-checkbox>
                    <el-select
                    :disabled="showAllDates"
                              class=""
                              size="small"
                              placeholder="Select month"
                              v-model="monthValue"
                              @change="calculateMonth"
                              no-data-text="Select Term First!"
                              >
                                
                      <el-option v-for="option in searchMonth"
                                class="select-danger"
                                :value="option.value"
                                :label="option.label"
                                :key="option.label">
                      </el-option>
                    </el-select>

                    <el-select
                              class=""
                              size="small"
                              placeholder="Select year"
                              v-model="monthModifier"
                              @change="calculateMonth"
                              no-data-text="Select Term First!"
                              >
                      <el-option v-for="option in searchYear"
                                class="select-danger"
                                :value="option.value"
                                :label="option.label"
                                :key="option.label">
                      </el-option>
                    </el-select>

                    <el-select
                      size="small"
                      class="form-group border-input"
                      placeholder="Select Country"
                      v-model="country"
                      @change="getTownsByCountry"
                    >
                      <el-option
                        v-for="(country,index) in countries"
                        class="select-default"
                        :value="country"
                        :label="index"
                        :key="index"
                      ></el-option>
                    </el-select>
                      
                    
                    <el-select
                      size="small"
                      class="form-group border-input"
                      placeholder="Select Location"
                      v-model="town"
                      v-if="showTowns"
                      @change="getClassrooms"
                    >
                      <el-option
                        v-for="(town,index) in towns"
                        class="select-default"
                        :value="town.town"
                        :label="town.town"
                        :key="index"
                      ></el-option>
                    </el-select>

                    <el-button type="danger" size="small" round @click="resetFilters">Reset</el-button>

                  </el-col>
                
                  
                </el-form>

            </el-row>

            <div class="table-responsive">
              <data-tables-server
                class="table-shopping"
                style="width: 100%"
                :empty-text="'Sorry No Available Classrooms'"
                :data="classrooms"
                :tool-bar="false"
              
                :total="total"
                :loading="loadingClassrooms"
                @query-change="getClassrooms"
            
              >

                    <el-table-column label="Type" min-width="6">
                      <template slot-scope="props">
                        <span class="label label-primary" v-if="props.row['length'] == '2'">Weekend</span>
                        <span class="label label-warning" v-if="props.row['length'] == '3'">Weekday</span>
                        <span class="label label-danger" v-if="props.row['length'] == '4'">V. Weekend</span>
                        <span class="label label-success" v-if="props.row['length'] == '6'">V. Weekday</span>
                        <span class="label label-info" v-if="props.row['length'] == '5'">V. OTP</span>

                      </template>
                    </el-table-column>
                    <el-table-column label="Status" min-width="6">
                      <template slot-scope="props">
                        <span class="label label-danger" v-if="props.row.historic == '1' && props.row.isPublic == '0'">Cancelled</span>
                        <span class="label label-warning" v-if="props.row.historic != '1' && props.row.isPublic == '0'">Inactive</span>
                        <span class="label label-success" v-if="props.row.historic != '1' && props.row.isPublic == '1'">Active</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="Date" min-width="12" prop="startDate" sortable>
                      <template slot-scope="props"><strong>Start:</strong> {{props.row.startDate | moment('ddd, MMM Do, YYYY')}}<br><strong>End:</strong> {{props.row.endDate | moment('ddd, MMM Do, YYYY')}}</template>
                    </el-table-column>
                    <el-table-column label="Sessions" min-width="11" v-if="days > 3">
                      <template slot-scope="props">
                        <span v-if="props.row.code != 'flexible' && props.row.sessions.length>0">
                          <strong>Times: </strong><br>
                          {{props.row.startDate+' '+props.row.startTime | correctTime}} - {{props.row.startDate+' '+props.row.endTime | correctTime}}<br><br>
                          <strong>Dates: </strong><br>
                          <span v-if="props.row.sessions[0]">1. {{props.row.sessions[0] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[1]">2. {{props.row.sessions[1] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[2]">3. {{props.row.sessions[2] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[3]">4. {{props.row.sessions[3] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[4]">5. {{props.row.sessions[4] | moment('ddd, MMM Do')}}</span><br>
                          <span v-if="props.row.sessions[5]">6. {{props.row.sessions[5] | moment('ddd, MMM Do')}}</span>
                        </span>
                        <span v-if="props.row.code == 'flexible'">
                          <strong>Flexible holding course</strong>
                        </span>
                        <span v-if="!props.row.sessions">
                          <strong>No sessions</strong>
                        </span>
                      </template>
                    </el-table-column>

                    <el-table-column label="Code" min-width="7">
                      <template slot-scope="props">{{props.row.code}}</template>
                    </el-table-column>

                    <el-table-column label="Meeting Details" min-width="12" v-if="days > 3">
                      <template slot-scope="props">
                        <span v-if="props.row.meetingID">
                          <strong>ID: </strong>{{props.row.meetingID}}<br>
                        </span>
                        <span v-if="props.row.meetingUrl">
                          <strong>URL: </strong><a :href="props.row.meetingUrl">{{props.row.meetingUrl}}</a><br>
                        </span>
                        <span v-else>
                          No meeting details
                        </span>
                      </template>
                    </el-table-column>
                    <!--
                    <el-table-column label="Occupancy" min-width="8" prop="numAttendees" sortable align="center">
                      <template slot-scope="props">
                        <strong>{{props.row.numAttendees}} / {{props.row.maxAttendees}}</strong><br>
                        <small
                          class="label label-info"
                          v-if="props.row.maxAttendees - props.row.numAttendees === 0"
                        >Full</small>
                        <small
                          class="label label-danger"
                          v-if="props.row.numAttendees === 0"
                        >Empty</small>
                      </template>
                    </el-table-column>
                    -->
                    <el-table-column label="Venue" min-width="15" v-if="days < 4">
                      <template slot-scope="props">{{props.row.venue.name}}</template>
                    </el-table-column>

                    <el-table-column label="Town" min-width="15" v-if="days < 4">
                      <template slot-scope="props">{{props.row.venue.town}}</template>
                    </el-table-column>

                    <el-table-column label="Location" min-width="8" v-if="days === 999">
                      
                      <template slot-scope="props">
                        <span v-if="props.row.venue">
                          {{props.row.venue.town}}
                        </span>
                        <span v-else>
                          Online
                        </span>
                      </template>

                    </el-table-column>

                    <!--
                      <el-table-column label="Available to take class?" min-width="15">
                      <template slot-scope="props">
                        <el-checkbox :checked="checkAvailable(props.row.id)" :true-label="props.row.id" :false-label="props.row.id" @change="saveChanges(props.row.id)">Available</el-checkbox>
                      </template>
                    </el-table-column>
                    -->
                    <el-table-column label="Notes" min-width="5">
                      <template slot-scope="props">
                          <el-popover v-if="props.row.notes"
    placement="bottom"
    title="Class Notes"
    width="200"
    trigger="click"
    :content="props.row.notes">
    <el-button size="mini" slot="reference">View</el-button>
    
  </el-popover><span v-else>-</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="Available to take class?" min-width="15">
                      <template slot-scope="props">
                        <el-checkbox :checked="tutorAvailabilities.includes(props.row.id)" :value="tutorAvailabilities.includes(props.row.id)" @change="saveChanges($event, props.row.availableTutors, props.row.id)">Yes, I am available</el-checkbox>
                      </template>
                    </el-table-column>
                    <template slot="empty"><h2>Sorry No Classrooms Available </h2><p>This probably means a tutor has already been assigned for all the classrooms in this date range, or if it's too far in the future, there are no classrooms scheduled yet for those dates. </p></template>
              </data-tables-server>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import json from "../../data/countries_filter.json";
import gql from "graphql-tag";
import moment from "moment";

/*
const CREATE_AVAILABILITY=gql`
mutation createAvailability($availability: [TutorAvailability_insert_input!]!){
  insert_TutorAvailability(objects:$availability){
    returning{
      id
    }
    affected_rows
  }
}
`;

const DELETE_AVAILABILITY=gql`
mutation deleteAvailability($id: Int){
  delete_TutorAvailability(where: { id: { _eq: $id } }){
    affected_rows
  }
}
`;
*/

const UPDATE_AVAILABILITY = gql`
  mutation updateAvailability($id: Int, $availableTutors: _int4) {
    update_ClassRoom(
      where: { id: { _eq: $id } }
      _set: { availableTutors: $availableTutors }
    ) {
      returning {
        id
        availableTutors
        aTutors {
          id
          firstname
          lastname
        }
      }
      affected_rows
    }
  }
`;

export default {
  props: ["property", "value"],
  data() {
    return {
      countries: json,
      towns: {},
      
      town: null,
      country: "Any",
      showTowns: false,
      loadingClassrooms: false,
      customerTitles: ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof", "Rev"],
      classrooms: [],
      customer: {},
      tutor: {},
      tutorID: null,
      tutorAvailabilities: [],
      dialogVisible: false,
      loading: false,
      error: null,
      total: 0,
      days: 999,
      unassigned: "false",
      available: false,
      availability: {},
      daysArray: [
        {
          value: 999,
          label: "All Classrooms",
        },
        {
          value: 2,
          label: "Weekend Classrooms (20 hour)",
        },
        {
          value: 3,
          label: "Weekday Classrooms (30 hour)",
        },
        {
          value: 4,
          label: "Weekend Virtual (20 hour)",
        },
        {
          value: 6,
          label: "Weekday Virtual (30 hour)",
        },
        {
          value: 5,
          label: "OTP Virtual",
        },
      ],
      selectedProperty: "",
      selectedValue: "",
      searchMonth: [
        { value: "1", label: "January" },
        { value: "2", label: "February" },
        { value: "3", label: "March" },
        { value: "4", label: "April" },
        { value: "5", label: "May" },
        { value: "6", label: "June" },
        { value: "7", label: "July" },
        { value: "8", label: "August" },
        { value: "9", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
      ],
      searchYear: [
        { value: "0", label: "This year" },
        // {value:"-12",label:"Last Year"},
        { value: "+12", label: "Next Year" },
      ],
      monthValue: String(moment().month()),
      monthModifier: "0",
      currentProp: "month",
      currentVal: 1,
      showAllDates: false,
    };
  },

  methods: {
    async getClassrooms() {
      this.classrooms = [];

      if (this.country == "Online") {
        this.town = "Online";
      }

      if (this.country == "Any") {
        this.town = null;
      }

      this.loadingClassrooms = true;

      var property = this.currentProp;
      var value = this.currentVal;

      var length = this.days === 999 ? "_neq" : "_eq";

      let qWhere;
      //altered to showAlldates for next 6 months
      qWhere = `where:{_and: {startDate: {_gte: "${
        this.showAllDates
          ? moment().format("YYYY-MM-DD")
          : moment()
              .month(value - 1)
              .startOf("month")
              .format("YYYY-MM-DD")
      }",_lte:"${
        this.showAllDates
          ? moment().add(6, "months").format("YYYY-MM-DD")
          : moment()
              .month(value - 1)
              .endOf("month")
              .format("YYYY-MM-DD")
      }"}, length: {${length}: "${this.days}"}`;

      qWhere += `, tutorId: {_is_null: true}`;
      //Filter out any cancelled or inactive classrooms
      qWhere += `, historic: {_neq: 1}`;
      /// now they want to see any inactive not live classes
      // qWhere += `, isPublic: {_eq: 1}`

      if (this.town && this.town != null) {
        var fixTown = "";
        this.town == "chester" || this.town == "Chester"
          ? (fixTown = "chester")
          : (fixTown = "%" + this.town + "%");
        qWhere += `, venue: {town: {_ilike: "${fixTown}"}}`;
      }

      qWhere += `}}`;

      this.$apollo
        .query({
          query: gql`
              {
                ClassRoom(
                  limit: 150,
                  ${qWhere},
                  order_by: {startDate: asc}
                ) {
                  id
                  additionalCost
                  allRatingsPercentage
                  code
                  courseRatingPercentage
                  dateCreated
                  dateUpdated
                  endDate
                  startTime
                  endTime
                  isOnline
                  historic
                  isPublic
                  length
                  sessions
                  meetingUrl
                  meetingID
                  maxAttendees
                  numAttendees
                  numberOfTens
                  tutorId
                  startDate
                  venueId
                  notes
                  availableTutors
                  aTutors{
                    id
                    firstname
                    lastname
                  }
                  venue {
                    id
                    name
                    line1
                    town
                  }
                  attendees {
                    customer {
                      id
                      firstname
                      lastname
                    }
                  }
                  tutor {
                    email
                    emailVerified
                    firstname
                    id
                    isActive
                    lastname
                    rating
                    username
                  }
                }
              

            }`,
          error(error) {
            this.error = JSON.stringify(error);
          },
        })
        .then((result) => {
          this.classrooms = result.data.ClassRoom;
          this.buildAvailability();
          this.total = this.classrooms.length;
          this.loadingClassrooms = false;
        });
    },

    buildAvailability() {
      //Populate availabilities
      this.tutorAvailabilities = [];
      console.log("Tutor ID 1: ", this.tutorID);
      var vm = this;
      this.classrooms.forEach(function (classroom) {
        console.log("Tutor ID 2: ", vm.tutorID);
        console.log("Classroom: ", classroom);
        if (classroom.aTutors && classroom.aTutors !== null) {
          var availabilities = Object.values(classroom.aTutors);
          availabilities.forEach(function (availability) {
            console.log("Tutor ID 3: ", vm.tutorID);
            console.log("Availability: ", availability);
            if (availability.id == vm.tutorID) {
              console.log("Adding classroom: ", classroom.id);
              console.log("Availability ID: ", availability.id);
              console.log("Tutor ID 4: ", vm.tutorID);
              vm.tutorAvailabilities.push(classroom.id);
            }
          });
        }
      });
      console.log("Availabilities: ", this.tutorAvailabilities);
    },

    getTownsByCountry(country) {
      //console.log('country',country);
      if (country && country == "Online") {
        this.showTowns = false;
        this.town = "Online";
        this.getClassrooms();
      }
      if (country && country != "Online" && country != "Any") {
        this.$apollo
          .query({
            query: gql`
            {
              ClassRoomVenue(where: {country: {_eq: "${country}"}}, distinct_on: town) {
                town
              }
            }`,
            error(error) {
              this.error = JSON.stringify(error);
            },
          })
          .then((result) => {
            this.towns = result.data.ClassRoomVenue;
            this.showTowns = true;
          });
      } else {
        this.showTowns = false;
        this.town = null;
        this.getClassrooms();
      }
    },

    checkAvailable(classRoomId) {
      var found = this.tutorAvailabilities.includes(classRoomId);
      console.log("Found:", found);
      return found;
    },

    saveChanges(checked, aTutors, classRoomId) {
      console.log("Value: ", checked);
      console.log("Tutors Array: ", aTutors);
      console.log("ClassroomId: ", classRoomId);
      console.log("TutorId: ", this.tutorID);
      var availabilities = "{" + this.tutorID + "}";
      var found = false;
      //IS THIS THE FIRST TIME WE'RE SETTING THIS?
      if (!aTutors || aTutors === null || aTutors.length === 0) {
        //Add and keep defaults
        console.log(
          "Inititate availability: ",
          availabilities,
          classRoomId,
          this.tutorID
        );
        var check = this.tutorAvailabilities.includes(classRoomId);
        console.log("Check: ", check, checked);
        if (check === checked) {
          console.log("MISMATCH!");
          //Handle mismatch
          check = !check;
        }
        if (!check) {
          //Add
          this.tutorAvailabilities.push(classRoomId);
          //Check there are no duplicates
          this.tutorAvailabilities = [...new Set(this.tutorAvailabilities)];
        } else {
          //Remove
          this.tutorAvailabilities = this.tutorAvailabilities.filter(
            (item) => item !== classRoomId
          );
          //Check there are no duplicates
          this.tutorAvailabilities = [...new Set(this.tutorAvailabilities)];
          availabilities = "{}";
        }
        //this.updateAvailability(availabilities, classRoomId);
      } else {
        //Check if we are adding or removing
        //Convert to array
        availabilities = Object.values(aTutors);
        found = availabilities.includes(this.tutorID);
        console.log(
          "Found? ",
          availabilities,
          classRoomId,
          this.tutorID,
          found,
          checked
        );
        if (found === checked) {
          console.log("MISMATCH!");
          //Handle mismatch
          found = !found;
        }
        if (!found) {
          //Add
          console.log(
            "CASE 1 (ADD): ",
            availabilities,
            classRoomId,
            this.tutorID
          );
          availabilities.push(this.tutorID);
          this.tutorAvailabilities.push(classRoomId);
          //Check there are no duplicates
          availabilities = [...new Set(availabilities)];
          this.tutorAvailabilities = [...new Set(this.tutorAvailabilities)];
          //Convert back to string
          availabilities = availabilities.toString();
          //Remove trailing comma if there is one
          availabilities = availabilities.replace(/,\s*$/, "");
          //Format for Hasura
          availabilities = "{" + availabilities + "}";
        } else {
          //Remove
          console.log(
            "CASE 2 (REMOVE): ",
            availabilities,
            classRoomId,
            this.tutorID
          );
          availabilities = availabilities.filter(
            (item) => item !== this.tutorID
          );
          this.tutorAvailabilities = this.tutorAvailabilities.filter(
            (item) => item !== classRoomId
          );
          //Check there are no duplicates
          availabilities = [...new Set(availabilities)];
          this.tutorAvailabilities = [...new Set(this.tutorAvailabilities)];
          //Convert back to string
          availabilities = availabilities.toString();
          //Remove trailing comma if there is one
          availabilities = availabilities.replace(/,\s*$/, "");
          //Format for Hasura
          availabilities = "{" + availabilities + "}";
        }
      }
      console.log("After IF: ", availabilities, classRoomId, this.tutorID);
      console.log("Updated tutor availability: ", this.tutorAvailabilities);
      this.updateAvailability(availabilities, classRoomId);
    },

    updateAvailability(availabilities, classRoomId) {
      console.log("Data: ", availabilities, classRoomId);
      this.$apollo
        .mutate({
          mutation: UPDATE_AVAILABILITY,
          variables: {
            id: classRoomId,
            availableTutors: availabilities,
          },
        })
        .then((result) => {
          this.$notify({
            title: "Success",
            message: "Availability Saved",
            type: "success",
          });
        })
        .catch((error) => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error",
          });
        });
    },

    /*

    checkAvailable(id){
      var availabilities = this.tutor.TutorAvailabilities
      var found = availabilities.some(el => el.classRoomId == id);
      return found;
    },

    saveChanges(id){
      var availabilities = this.tutor.TutorAvailabilities
      var av = availabilities.find(el => el.classRoomId == id);
      console.log('id',id);
      console.log('availabilities',availabilities);
      console.log('av',av);
      if(av !== undefined){
        this.deleteAvailability(av.id);
      } else {
        this.saveAvailability(id);
      }
      this.checkAvailable(id);
    },

    deleteAvailability(classRoomId) {
      this.$apollo.mutate({
        mutation:DELETE_AVAILABILITY,
        variables:{
          id:classRoomId
        }
      }).then(result => {
        this.$notify({
            title: "Success",
            message: "Availability Saved",
            type: "success"
        });
      }).catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      });
      this.getTutor(this.$store.getters.getProfile.id);
    },

    saveAvailability(classRoomId) {
      this.availability.tutorId = this.tutorID
      this.availability.classRoomId = classRoomId
      const availability = this.availability && this.availability
      this.$apollo.mutate({
        mutation:CREATE_AVAILABILITY,
        variables:{
          availability:availability
        }
      }).then(result => {
        this.$notify({
            title: "Success",
            message: "Availability Saved",
            type: "success"
        });
      }).catch(error => {
        this.$notify({
          title: "Error",
          message: error.message,
          type: "error"
        });
      });
      this.getTutor(this.$store.getters.getProfile.id);
    },


    getTutor(id){
      this.$apollo
      .query({
        query: gql`
          {
            Tutor_by_pk(id: "${id}") {
              id
              firstname  
              lastname
              email
              rating
              username
              password
              currency
              notes{
                id
                detail
              }
              address {
                id
                line1
                line2
                postcode
                country
                phone
                fax
              }
              isActive
              TutorAvailabilities{
                id
                tutorId
                classRoomId
              }
            }
          }
        `,
        // can get error if needed
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.tutor = response.data.Tutor_by_pk;
      });
    },

    */

    calculateMonth() {
      this.currentVal =
        parseInt(this.monthValue) + parseInt(this.monthModifier);
      this.currentProp = "month";
      this.getClassrooms();
    },

    resetFilters() {
      this.towns = {};
      this.town = null;
      this.country = "Any";
      this.showTowns = false;
      this.classrooms = [];
      this.customer = {};
      this.tutors = [];
      this.tutor = "";
      this.days = 999;
      this.unassigned = "all";
      this.currentProp = "month";
      this.currentVal = 0;
      this.getClassrooms();
    },
  },
  mounted() {
    this.getClassrooms();
    this.tutorID = this.$store.getters.getProfile.id;
    console.log("Tutor ID: ", this.tutorID);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Tutor/SelectClassrooms.vue